import React, { useState } from "react";
import FormTitle from "../../../components/Common/FormTitle";
import FooterGoogle from "../../../components/Common/FooterGoogle";
import SignButton from "../../../components/Common/SignButton/SignButton";
import Input from "../../../components/Common/Input/Input";
import SubTitleLogin from "../../../components/Common/SubTitleLogin";
import PasswordInput from "../../../components/Common/PasswordInput/PasswordInput";
import { useContext } from "react";
import dataContext from "../../../context/dataContext";
import { validate } from "./validate";
import styles from "./style.module.css";
import authRequets from "../../../components/api/authRequests";
import { auth } from "../../../components/api/firebaseConfig";
import mainContext from "../../../context/mainContext";

const SignUp = () => {
  const [valid, setValid] = useState([]);
  const [error, setError] = useState(false);
  const { setUserDetails } = useContext(dataContext);
  const { loader: { loaderFetch, setLoaderFetch } } = useContext(mainContext)
  const getDatafromForm = (formData) => ({
    firstName: formData.get("firstName"),
    lastName: formData.get("lastName"),
    email: formData.get("email"),
    password: formData.get("password"),
    "confirm-password": formData.get("confirm-password"),
  });

  const onSubmit = async (e) => {
    e.preventDefault();
    const body = getDatafromForm(new FormData(e.currentTarget));
    const checkResult = validate(body);
    setValid(checkResult);

    if (body["password"] !== body["confirm-password"])
      checkResult.push("password", "confirm-password");

    if (checkResult.length) return;

    try {
      // Create user in Firebase Authentication
      setLoaderFetch(true);
      const userDetails = await authRequets.register(body);
      console.log("🚀 ~ file: SignUp.jsx:42 ~ onSubmit ~ userDetails:", userDetails)
      console.log("🚀 ~ file: SignUp.jsx:45 ~ onSubmit ~ auth:", auth)
      setUserDetails(userDetails)
      setLoaderFetch(false);
      // const user = userCredential.user;
      // // Store additional user details in Firestore
      // await app.collection("users").doc(user.uid).set({
      //   firstName: body.firstName,
      //   lastName: body.lastName,
      //   email: body.email,
      // });

      // console.log("User registered and data saved:", user);

      // localStorage.setItem("access_token", "YOUR_ACCESS_TOKEN");
      // localStorage.setItem("refresh_token", "YOUR_REFRESH_TOKEN");


    } catch (error) {
      setLoaderFetch(false);
      console.error("Error during registration:", error);
    }
  };
  return (
    <form className={styles["sign-up"]} onSubmit={onSubmit} style={window.buildType == "iPhone" ? { minHeight: "100%" } : {}}>
      <FormTitle content="Create an Account" />
      <SubTitleLogin
        content="Already have an account?"
        link="/"
        sign="In"
      />
      <Input
        legend="First Name"
        content="First Name"
        type="text"
        name="firstName"
        valid={!valid.includes("firstName")}
      />
      <Input
        content="Last Name"
        type="text"
        name="lastName"
        legend="Last Name"
        valid={!valid.includes("lastName")}
      />
      <Input
        legend="Email"
        content="Email"
        type="email"
        name="email"
        valid={!valid.includes("email")}
      />
      <PasswordInput
        legend="Password"
        content="Password"
        name="password"
        placeholder="******"
        valid={!valid.includes("password")}
      />
      <PasswordInput
        legend="Confirm Password"
        content="Confirm Password"
        name="confirm-password"
        placeholder="******"
        valid={!valid.includes("confirm-password")}
      />
      {error &&

        <SubTitleLogin
          content={error}
          color="red"
        //  link="login"
        //  sign="In"
        />
      }
      <div className={styles.btnHolder}>
        <SignButton content="Sign Up" type="submit" />
      </div>
      <FooterGoogle CreateAccount />
    </form>
  );
};

export default SignUp;
